import { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import Card from 'components/UI/Card';
import Heading, { Type as HeadingType } from 'components/UI/Heading';
import { CardHeaderTop, CardHeaderTopColumn, Grid } from './styled';
import { Column } from 'styles';
import XmlInputField from '../XmlInputField';
import { HusqiotBusAttribute } from 'models/husqiotbus';

type Props = {
  addresses: string | undefined;
  security: string | undefined;
  devDiverts: string | undefined;
  qaDiverts: string | undefined;
  liveDiverts: string | undefined;
  extension: string | undefined;
  onChange: (name: string, value: string) => void;
};

const HusqiotBusOutput: FC<Props> = ({
  addresses,
  security,
  devDiverts,
  qaDiverts,
  liveDiverts,
  extension,
  onChange,
}) => {
  return (
    <Grid>
      <Column>
        <Card>
          <CardHeaderTop>
            <CardHeaderTopColumn>
              <Heading type={HeadingType.h3} uppercase>
                <FormattedMessage id="husqiotbus.addresses" />
              </Heading>
            </CardHeaderTopColumn>
          </CardHeaderTop>
          <XmlInputField
            defaultValue={addresses}
            rows={20}
            name={HusqiotBusAttribute.XmlAddresses}
            onChange={onChange}
          />
        </Card>
        <Card>
          <CardHeaderTop>
            <CardHeaderTopColumn>
              <Heading type={HeadingType.h3} uppercase>
                <FormattedMessage id="husqiotbus.security_settings" />
              </Heading>
            </CardHeaderTopColumn>
          </CardHeaderTop>
          <XmlInputField
            defaultValue={security}
            rows={20}
            name={HusqiotBusAttribute.XmlSecuritSettings}
            onChange={onChange}
          />
        </Card>
        <Card>
          <CardHeaderTop>
            <CardHeaderTopColumn>
              <Heading type={HeadingType.h3} uppercase>
                <FormattedMessage id="husqiotbus.extensions" />
              </Heading>
            </CardHeaderTopColumn>
          </CardHeaderTop>
          <XmlInputField
            defaultValue={extension}
            rows={20}
            name={HusqiotBusAttribute.XmlHusqiotExtensions}
            onChange={onChange}
          />
        </Card>
      </Column>
      <Column>
        <Card>
          <CardHeaderTop>
            <CardHeaderTopColumn>
              <Heading type={HeadingType.h3} uppercase>
                <FormattedMessage id="husqiotbus.devDiverts" />
              </Heading>
            </CardHeaderTopColumn>
          </CardHeaderTop>
          <XmlInputField
            defaultValue={devDiverts}
            rows={20}
            name={HusqiotBusAttribute.XmlDevDiverts}
            onChange={onChange}
          />
        </Card>
        <Card>
          <CardHeaderTop>
            <CardHeaderTopColumn>
              <Heading type={HeadingType.h3} uppercase>
                <FormattedMessage id="husqiotbus.qaDiverts" />
              </Heading>
            </CardHeaderTopColumn>
          </CardHeaderTop>
          <XmlInputField
            defaultValue={qaDiverts}
            rows={20}
            name={HusqiotBusAttribute.XmlQaDiverts}
            onChange={onChange}
          />
        </Card>
        <Card>
          <CardHeaderTop>
            <CardHeaderTopColumn>
              <Heading type={HeadingType.h3} uppercase>
                <FormattedMessage id="husqiotbus.liveDiverts" />
              </Heading>
            </CardHeaderTopColumn>
          </CardHeaderTop>
          <XmlInputField
            defaultValue={liveDiverts}
            rows={20}
            name={HusqiotBusAttribute.XmlLiveDiverts}
            onChange={onChange}
          />
        </Card>
      </Column>
    </Grid>
  );
};

export default HusqiotBusOutput;
